import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { ReportAccessItem } from '../models/reportAccess.types'

/** Account-scoped report list backing module 08's public access gate. */
export const useReportAccessStore = defineStore('reportAccess', () => {
  const accountId = ref<number | null>(null)
  const reports = ref<ReportAccessItem[]>([])

  /** Clear prior-tenant metadata before accepting a new account's degraded bootstrap. */
  function selectAccount(nextAccountId: number): void {
    if (accountId.value !== null && accountId.value !== nextAccountId) reset()
    accountId.value = nextAccountId
  }

  function setReports(next: ReportAccessItem[]): void {
    reports.value = next.map((report) => ({ ...report }))
  }

  function reportById(reportId: number): ReportAccessItem | null {
    return reports.value.find((report) => report.id === reportId) ?? null
  }

  function reportsByType(type: string): ReportAccessItem[] {
    return reports.value.filter((report) => report.type === type)
  }

  function reset(): void {
    accountId.value = null
    reports.value = []
  }

  return {
    accountId,
    reports,
    selectAccount,
    setReports,
    reportById,
    reportsByType,
    reset,
  }
})

export type ReportAccessStore = ReturnType<typeof useReportAccessStore>
